import axios from 'axios'

const axiosApi = axios.create({
  baseURL: `${import.meta.env.VITE_API_URL}/api/v1/`,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
  },
})

const axiosApiV2 = axios.create({
  baseURL: `${import.meta.env.VITE_API_URL}/api/v2/`,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
  },
})

export { axiosApiV2 }
export default axiosApi
